export class Droit {
    constructor(
        public id : number,
        public designation : string
    ){}
}
